import { render, staticRenderFns } from "./BackOfficeTab.vue?vue&type=template&id=1461b7ce&scoped=true"
import script from "./BackOfficeTab.vue?vue&type=script&lang=js"
export * from "./BackOfficeTab.vue?vue&type=script&lang=js"
import style0 from "./BackOfficeTab.vue?vue&type=style&index=0&id=1461b7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461b7ce",
  null
  
)

export default component.exports